import config from '@config';
import {
  initializeHttp,
  setupCookieUnauthorizedInterceptorFabric,
  setupCsrfInterceptor,
  setupOrganizationSessionInterceptor,
  setupRequestInterceptor,
  setupServerErrorInterceptor,
} from '@gasbi/shared/common/utils/http';

// Cookie (BFF) session (GSB-7613): no token in the browser - every call carries X-CSRF,
// a 401 navigates to the Households API's /api/login. The active organization lives in
// that session too (GSB-8274): a 403 organization_unavailable re-reads it.
const instance = initializeHttp(config.VITE_API_URL, [
  setupRequestInterceptor,
  setupOrganizationSessionInterceptor,
  setupCsrfInterceptor,
  setupCookieUnauthorizedInterceptorFabric('/api/login'),
  setupServerErrorInterceptor,
]);

export default instance;
